import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  slot: "start",
  class: "center"
}
const _hoisted_2 = {
  key: 1,
  slot: "end",
  class: "center"
}
const _hoisted_3 = {
  key: 2,
  slot: "icon-only"
}

import { IonButton } from "@ionic/vue";
import { computed } from "vue";

import { BUTTON_TYPE, ION_ROUTER_DIRECTION, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonButtonProps } from "@/types/props";
import { IonButtonEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonBase',
  props: {
    buttonType: { default: BUTTON_TYPE.BUTTON },
    color: { default: ION_VARIANT.CORAL },
    disabled: { type: Boolean, default: false },
    download: {},
    expand: {},
    fill: {},
    href: {},
    mode: {},
    rel: {},
    routerAnimation: {},
    routerDirection: { default: ION_ROUTER_DIRECTION.FORWARD },
    shape: {},
    size: {},
    strong: { type: Boolean, default: false },
    target: {},
    type: { default: BUTTON_TYPE.BUTTON },
    height: {},
    arrow: { type: Boolean },
    isShow: { type: Boolean }
  },
  emits: ["blur", "focus"],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v259120f3": (height.value)
}))

const props = __props



const height = computed(() => props.height ? props.height + 'px' : '50px');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    class: "base-button",
    "button-type": __props.buttonType,
    color: __props.color,
    disabled: __props.disabled,
    download: __props.download,
    expand: __props.expand,
    fill: __props.fill,
    href: __props.href,
    mode: "ios",
    rel: __props.rel,
    "router-animation": __props.routerAnimation,
    "router-direction": __props.routerDirection,
    shape: __props.shape,
    size: __props.size,
    strong: __props.strong,
    target: __props.target,
    type: __props.type,
    onIonBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('blur'))),
    onIonFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focus')))
  }, {
    default: _withCtx(() => [
      (_ctx.$slots['start'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "start")
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.$slots['end'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "end")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots['icon-only'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "icon-only")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["button-type", "color", "disabled", "download", "expand", "fill", "href", "rel", "router-animation", "router-direction", "shape", "size", "strong", "target", "type"]))
}
}

})